const AttachmentsTypeEnum = {
    blog: 'blog',
    user: "user"
}

export default {
    AttachmentsTypeEnum: Object.freeze(AttachmentsTypeEnum)
};